import { STLExporter } from "three/addons/exporters/STLExporter.js";

function saveStlFromMesh(mesh, fileName) {
  const stlExporter = new STLExporter();
  const data = stlExporter.parse(mesh, { binary: true });
  const blob = new Blob([data], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // "data.json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url); // cleanup
}

function saveLocalJson(data, fileName) {
  // const data = { name: "John", age: 30, city: "New York" };
  const json = JSON.stringify(data, null, 2); // pretty print

  const blob = new Blob([json], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // "data.json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url); // cleanup
}

function saveBlob(blob, filename) {
  const strDataUrl = URL.createObjectURL(blob);
  saveFile(strDataUrl, filename);
}

function saveFile(strDataUrl, filename) {
  const link = document.createElement("a");
  // if (typeof link.download === "string") {
  document.body.appendChild(link); //Firefox requires the link to be in the body
  link.download = filename;
  link.href = strDataUrl;
  link.click();
  document.body.removeChild(link); //remove the link when done
  // } else {
  // 	location.replace(uri);
  // }
}

function getFormattedDate(isFullDate) {
  var date = new Date();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month.toString().length == 1) {
    month = "0" + month;
  }
  if (day.toString().length == 1) {
    day = "0" + day;
  }

  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  if (hours.toString().length == 1) {
    hours = "0" + hours;
  }
  if (minutes.toString().length == 1) {
    minutes = "0" + minutes;
  }
  if (seconds.toString().length == 1) {
    seconds = "0" + seconds;
  }

  return isFullDate
    ? `${day}_${month}_${date.getFullYear()}.${hours}_${minutes}_${seconds}`
    : `${date.getFullYear()}_${month}_${day}`;
}

function getFullDate() {
  var date = new Date();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month.toString().length == 1) {
    month = "0" + month;
  }
  if (day.toString().length == 1) {
    day = "0" + day;
  }

  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  if (hours.toString().length == 1) {
    hours = "0" + hours;
  }
  if (minutes.toString().length == 1) {
    minutes = "0" + minutes;
  }
  if (seconds.toString().length == 1) {
    seconds = "0" + seconds;
  }

  return `${date.getFullYear()}.${month}.${day} ${hours}:${minutes}:${seconds}`;
}

function getShortDate() {
  var date = new Date();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return `${month}/${day}/${date.getFullYear()}`;
}

function zeroPad(num, places) {
  return String(num).padStart(places, "0");
}

//#region Obsolete
function downloadFileAndSave(fileUrl, filename) {
  window.URL = window.URL || window.webkitURL;

  var xhr = new XMLHttpRequest(),
    a = document.createElement("a"),
    file;

  xhr.open("GET", fileUrl, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    file = new Blob([xhr.response], { type: "application/octet-stream" });
    a.href = window.URL.createObjectURL(file);
    a.download = filename; // Set to whatever file name you want
    // Now just click the link you created
    // Note that you may have to append the a element to the body somewhere
    // for this to work in Firefox
    a.click();
  };
  xhr.send();
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function blobToDataURL(blob, callback) {
  // URL.createObjectURL(blob);
  var a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  };
  a.readAsDataURL(blob);
}

//#endregion

export {
  saveBlob,
  saveFile,
  getFormattedDate,
  getShortDate,
  getFullDate,
  zeroPad,
  saveLocalJson,
  saveStlFromMesh,
};
